/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBedNoteRequest
 */
export interface UpdateBedNoteRequest {
    /**
     * The note to set for the bed
     */
    note: string | null;
}

/**
 * Check if a given object implements the UpdateBedNoteRequest interface.
 */
export function instanceOfUpdateBedNoteRequest(value: object): value is UpdateBedNoteRequest {
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function UpdateBedNoteRequestFromJSON(json: any): UpdateBedNoteRequest {
    return UpdateBedNoteRequestFromJSONTyped(json, false);
}

export function UpdateBedNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBedNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'],
    };
}

export function UpdateBedNoteRequestToJSON(json: any): UpdateBedNoteRequest {
    return UpdateBedNoteRequestToJSONTyped(json, false);
}

export function UpdateBedNoteRequestToJSONTyped(value?: UpdateBedNoteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
    };
}

